<div class="booking-widget-container">
    <p-progressbar *ngIf="loadingStates.page" mode="indeterminate" [style]="{'height': '6px'}" />

    <p-card *ngIf="!loadingStates.page" class="booking-card">
        <p-message *ngIf="messages" [severity]="messages.severity" [text]="messages.summary" [closable]="false"
            styleClass="w-full mb-3" />

        <p-stepper [value]="1" [linear]="true">
            <p-step-list>
                <p-step [value]="1">Time Slot</p-step>
                <p-step [value]="2">Information</p-step>
                <p-step [value]="3">Payment</p-step>
            </p-step-list>
            <p-step-panels>
                <p-step-panel [value]="1">
                    <ng-template pTemplate="content" let-activateCallback="activateCallback">
                        <div class="grid">
                            <div class="col-12 md:col-6">
                                <label for="date-picker">Date</label>
                                <p-datepicker [(ngModel)]="selectedDate" [showIcon]="true" [showButtonBar]="true"
                                    [readonlyInput]="true" inputId="date-picker" [minDate]="minDate" [maxDate]="maxDate"
                                    styleClass="w-full" (onSelect)="getAvailableTimeSlots()">
                                </p-datepicker>
                            </div>
                            <div class="col-12 md:col-6">
                                <label for="simulator-dropdown">Simulator</label>
                                <p-select [options]="simulators" [(ngModel)]="selectedSimulator" optionLabel="bayName"
                                    [disabled]="!isValid([selectedDate])" placeholder="Select a Sim"
                                    (onChange)="getAvailableTimeSlots()" inputId="simulator-dropdown"
                                    styleClass="w-full">
                                </p-select>
                            </div>
                            <div class="col-12 md:col-6">
                                <label for="duration-dropdown">Duration</label>
                                <p-select [options]="bookingDurations" [(ngModel)]="selectedDuration"
                                    placeholder="Select a Duration" (onChange)="getAvailableTimeSlots()"
                                    [disabled]="!isValid([selectedDate, selectedSimulator])" inputId="duration-dropdown"
                                    styleClass="w-full">
                                    <ng-template pTemplate="selectedItem" let-selectedOption>
                                        {{formatDuration(selectedOption.durationMinutes)}}
                                    </ng-template>
                                    <ng-template let-duration pTemplate="item">
                                        {{formatDuration(duration.durationMinutes)}}
                                    </ng-template>
                                </p-select>
                            </div>
                            <div class="col-12 md:col-6">
                                <label for="timeslot-dropdown">Time Slot</label>
                                <p-select [options]="availableTimeSlots" [(ngModel)]="selectedTimeSlot"
                                    placeholder="Select a Time Slot" [loading]="loadingStates.timeSlots"
                                    styleClass="w-full"
                                    [disabled]="!isValid([selectedDate, selectedSimulator, selectedDuration])"
                                    inputId="timeslot-dropdown">
                                    <ng-template pTemplate="selectedItem" let-selectedOption>
                                        {{selectedOption.startTime | date: 'h:mm a'}} - {{selectedOption.endTime | date:
                                        'h:mm a'}}
                                    </ng-template>
                                    <ng-template let-timeslot pTemplate="item">
                                        {{timeslot.startTime | date: 'h:mm a'}} - {{timeslot.endTime | date: 'h:mm a'}}
                                    </ng-template>
                                </p-select>
                            </div>
                            <div class="col-12">
                                <div *ngIf="!showPromoCodeInput" class="text-primary"
                                    [class.cursor-pointer]="selectedTimeSlot" [class.text-disabled]="!selectedTimeSlot"
                                    (click)="selectedTimeSlot && (showPromoCodeInput = true)">
                                    Have a promo code?
                                </div>
                                <div *ngIf="showPromoCodeInput" class="d-flex align-items-center gap-2">
                                    <span class="p-input-icon-right flex-grow-1">
                                        <input type="text" pInputText [(ngModel)]="promoCode"
                                            placeholder="Enter promo code" class="w-100" inputId="promo-code">
                                    </span>
                                    <p-button label="Apply" (onClick)="applyPromoCode()"
                                        [loading]="loadingStates.promoCode"
                                        [disabled]="!promoCode || loadingStates.promoCode">
                                    </p-button>
                                    <button pButton pRipple type="button" icon="pi pi-times"
                                        class="p-button-rounded p-button-text" (click)="clearPromoCode()">
                                    </button>
                                </div>
                                <div *ngIf="appliedPromoCode" class="text-success mt-2">
                                    Promo code applied: {{appliedPromoCode.code}}
                                    ({{appliedPromoCode.discountType === DiscountType.Percentage ?
                                    appliedPromoCode.discountAmount + '%' : '$' + appliedPromoCode.discountAmount}} off)
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="d-flex justify-content-end">
                                    <p-button label="Next" icon="pi pi-arrow-right" iconPos="right"
                                        (onClick)="activateCallback(2); this.messages = [];"
                                        [disabled]="!isValid([selectedDate, selectedDuration, selectedSimulator, selectedTimeSlot])">
                                    </p-button>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </p-step-panel>
                <p-step-panel [value]="2">
                    <ng-template pTemplate="content" let-activateCallback="activateCallback" let-index="index">
                        <div class="container">
                            <div class="row mb-1">
                                <div class="col-12">
                                    <label for="customer-name">Customer Name</label>
                                    <input pInputText [(ngModel)]="customerName" id="customer-name"
                                        placeholder="Enter Name" class="full-width" required />
                                </div>
                            </div>
                            <div class="row mb-1">
                                <div class="col-12">
                                    <label for="email">Email</label>
                                    <input pInputText [(ngModel)]="email" type="email" inputId="email"
                                        placeholder="Enter Email Address" class="full-width" required 
                                        #emailInput="ngModel"
                                        pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}" />
                                    <small class="text-danger d-block mt-1" *ngIf="email && !isEmailValid()">
                                        Please enter a valid email address
                                    </small>
                                </div>
                            </div>
                            <div class="row mb-1">
                                <div class="col-12">
                                    <label for="phoneNumber">Phone Number</label>
                                    <input pInputText [(ngModel)]="phoneNumber" inputId="phoneNumber" type="tel"
                                        placeholder="Enter Phone Number" class="full-width" required />
                                </div>
                            </div>
                            <div class="row mb-1">
                                <div class="col-12">
                                    <label for="addons">Addons</label>
                                    <p-multiSelect [options]="availableAddons" [(ngModel)]="selectedAddons"
                                        optionLabel="name" placeholder="Select Addons" inputId="addons"
                                        styleClass="full-width">
                                        <ng-template let-addon pTemplate="item">
                                            <div class="flex align-items-center justify-content-between">
                                                <div>{{addon.name}} (${{addon.price}})</div>
                                            </div>
                                        </ng-template>
                                    </p-multiSelect>
                                </div>
                            </div>
                            <div class="row mb-1">
                                <div class="col-12">
                                    <label for="participants">Number of Golfers</label>
                                    <p-inputNumber [(ngModel)]="participants" [showButtons]="true"
                                        inputId="participants" [min]="0" [max]="6" required class="full-width" />
                                </div>
                            </div>
                            <div class="row mb-1">
                                <div class="col-12">
                                    <label for="description">Notes</label>
                                    <textarea rows="5" cols="30" [(ngModel)]="description" id="description"
                                        pInputTextarea [autoResize]="true" class="full-width">
                                            </textarea>
                                </div>
                            </div>
                            <div class="row mt-1">
                                <div class="col-12 d-flex justify-content-between">
                                    <p-button label="Back" icon="pi pi-arrow-left" (onClick)="activateCallback(1)" />
                                    <p-button label="Next" icon="pi pi-arrow-right" iconPos="right"
                                        [loading]="loadingStates.payment"
                                        [disabled]="!isValid([customerName, email, phoneNumber, participants]) || !isEmailValid() || loadingStates.payment"
                                        (onClick)="handleNext(activateCallback, 3)" />
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </p-step-panel>
                <p-step-panel [value]="3">
                    <ng-template pTemplate="content" let-activateCallback="activateCallback" let-index="index">
                        <div class="payment-step-content">
                            <div class="row">
                                <p-progressBar *ngIf="loadingStates.payment" mode="indeterminate"
                                    [style]="{'height': '6px'}" />
                            </div>
                            <div class="row mb-3">
                                <div class="col-12">
                                    <div class="d-flex justify-content-between align-items-center">
                                        <span class="font-bold">Total Amount:</span>
                                        <span class="font-bold">${{totalPrice.toFixed(2)}}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    @if (elementsOptions.clientSecret){
                                    <ngx-stripe-elements [stripe]="stripe" [elementsOptions]="elementsOptions">
                                        <ngx-stripe-payment [options]="paymentElementsOptions"
                                            (change)="onCardChange($event)" />
                                    </ngx-stripe-elements>
                                    }
                                </div>
                            </div>
                            <div class="row mt-3 payment-buttons-container">
                                <div class="col-12 d-flex justify-content-between">
                                    <p-button label="Back" icon="pi pi-arrow-left"
                                        (onClick)="handleCancelPaymentBack(activateCallback, 2)" />
                                    <p-button label="Submit" icon="pi pi-arrow-right" iconPos="right"
                                        [loading]="loadingStates.submission"
                                        [disabled]="loadingStates.submission || !isCardValid" (onClick)="submit()" />
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </p-step-panel>
            </p-step-panels>
        </p-stepper>
    </p-card>
</div>